import { render, staticRenderFns } from "./FieldType8.vue?vue&type=template&id=1358c44e&scoped=true"
import script from "./FieldType8.vue?vue&type=script&lang=js"
export * from "./FieldType8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358c44e",
  null
  
)

export default component.exports